import { InsightsMixpanelEventsNames } from "~/components/insights/mixpanelEvents";
import useTracking from "~/hooks/useTracking";
import { useNavigate } from "@remix-run/react";

interface Props {
  toggle: () => void;
  notificationCount: number;
  notificationLength: number;
  icon: React.ReactNode;
}

const NotificationBell = ({
  toggle,
  notificationCount,
  notificationLength,
  icon,
}: Props) => {
  const toggleNotificationList = () => {
    if (notificationLength > 0) toggle();
  };
  const tracking = useTracking();
  const navigate = useNavigate();

  return (
    <>
      <div
        className="relative mobile:hidden"
        onClick={() => {
          toggleNotificationList();
          tracking.track(
            InsightsMixpanelEventsNames.CLICKING_ON_ALL_THE_INSIGHT_BELL
          );
        }}
      >
        {notificationCount > 0 && (
          <div className="absolute left-[60%] top-[40%] flex h-5 w-5 -translate-y-full items-center justify-center rounded-full bg-redPrimary pt-[1px] text-center text-xs font-medium text-white drop-shadow-[0px_3px_4px_rgba(229,0,0,0.20)]">
            {notificationCount}
          </div>
        )}
        {icon}
      </div>
      <div
        className="relative hidden mobile:block"
        onClick={() => {
          tracking.track(
            InsightsMixpanelEventsNames.CLICKING_ON_ALL_THE_INSIGHT_BELL
          );
          navigate("/insights");
        }}
      >
        {notificationCount > 0 && (
          <div className="absolute left-[60%] top-[40%] flex h-5 w-5 -translate-y-full items-center justify-center rounded-full bg-redPrimary pt-[1px] text-center text-xs font-medium text-white drop-shadow-[0px_3px_4px_rgba(229,0,0,0.20)]">
            {notificationCount}
          </div>
        )}
        {icon}
      </div>
    </>
  );
};

export default NotificationBell;
